import React from "react";
import { Badge, Tooltip } from "@mantine/core";
import { useTranslation } from "react-i18next";
import type { DeprecationStatus } from "@models/providerCatalog";

const COLOR: Record<DeprecationStatus, string> = { retired: "red", retiring: "orange", deprecated: "yellow" };

/** `Retired 2026-01-01`, `Retires in 12 days` or `Retires 2027-03-01`, colored by urgency. */
const DeprecationBadge: React.FC<{
  deprecation: { status: DeprecationStatus; retire_on: string; days_left: number; replacement?: string | null };
}> = ({ deprecation }) => {
  const { t } = useTranslation();
  const label = deprecation.status === "retired"
    ? t("admin.models.deprecation.badge.retired", { date: deprecation.retire_on })
    : deprecation.status === "retiring"
      ? t("admin.models.deprecation.badge.retiring", { count: deprecation.days_left })
      : t("admin.models.deprecation.badge.deprecated", { date: deprecation.retire_on });
  return (
    <Tooltip label={deprecation.replacement ? t("admin.models.deprecation.replaceWith", { model: deprecation.replacement })
                                            : t("admin.models.deprecation.noReplacement")}>
      <Badge size="sm" variant="light" color={COLOR[deprecation.status]}>{label}</Badge>
    </Tooltip>
  );
};

export default DeprecationBadge;
